import { FcsPermissionPickupDashboard } from "@/feature-flags/flags-pickup-dashboard";

const Layout = () =>
  import(/* webpackChunkName: "Layout" */ "@/app/ui/layout/index.vue");

const PickupDashboardMonitoring = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoring" */ "@/app/ui/views/pickup-dashboard/monitoring/index.vue"
  );

const PickupDashboardMonitoringCourier = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/index.vue"
  );

const PickupDashboardMonitoringCourierDetail = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/detail/index.vue"
  );

const PickupDashboardMonitoringCourierDetailCRROTW = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/crrotw/index.vue"
  );

const PickupDashboardMonitoringCourierDetailCRRPIC = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/crrpic/index.vue"
  );

const PickupDashboardMonitoringCourierDetailCRRDON = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/crrdon/index.vue"
  );

const PickupDashboardMonitoringCourierDetailBKD = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/bkd/index.vue"
  );

const PickupDashboardMonitoringCourierDetailCRRCNC = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/crrcnc/index.vue"
  );

const PickupDashboardMonitoringCourierBookingPickup = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/booking-pickup/index.vue"
  );

const PickupDashboardMonitoringAllPickup = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringAllPickup" */ "@/app/ui/views/pickup-dashboard/monitoring/all-pickup/index.vue"
  );

const PickupDashboardMonitoringAllPickupCRROTW = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringAllPickup" */ "@/app/ui/views/pickup-dashboard/monitoring/all-pickup/crrotw/index.vue"
  );

const PickupDashboardMonitoringAllPickupCRRPIC = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringAllPickup" */ "@/app/ui/views/pickup-dashboard/monitoring/all-pickup/crrpic/index.vue"
  );

const PickupDashboardMonitoringAllPickupCRRDON = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringAllPickup" */ "@/app/ui/views/pickup-dashboard/monitoring/all-pickup/crrdon/index.vue"
  );

const PickupDashboardMonitoringAllPickupCRRNFD = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringAllPickup" */ "@/app/ui/views/pickup-dashboard/monitoring/all-pickup/crrnfd/index.vue"
  );

const PickupDashboardMonitoringCourierTransferPickup = () =>
  import(
    /* webpackChunkName: "PickupDashboardMonitoringCourier" */ "@/app/ui/views/pickup-dashboard/monitoring/courier/transfer-pickup/index.vue"
  );

const PickupDashboardManageArea = () =>
  import(
    /* webpackChunkName: "PickupDashboardManageArea" */ "@/app/ui/views/pickup-dashboard/manage-area/index.vue"
  );

const PickupDashboardManageAreaCreate = () =>
  import(
    /* webpackChunkName: "PickupDashboardManageArea" */ "@/app/ui/views/pickup-dashboard/manage-area/create.vue"
  );

export default [
  {
    path: "/pickup-dashboard",
    component: Layout,
    name: "pickup-dashboard",
    redirect: "/pickup-dashboard/monitoring",
    meta: {
      hidden: true,
      header: true,
      children: true,
      title: "Pickup Dashboard",
      name: "Pickup Dashboard",
      permission: [
        FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable,
        FcsPermissionPickupDashboard.permission_pickup_dashboard_manage_area_enable
      ]
    },
    children: [
      {
        path: "monitoring",
        component: PickupDashboardMonitoring,
        name: "pickup-dashboard-monitoring",
        redirect: "/pickup-dashboard/monitoring/courier",
        meta: {
          icon: "home",
          header: true,
          name: "Monitoring",
          permission: [
            FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
          ]
        },
        children: [
          {
            path: "courier",
            component: PickupDashboardMonitoringCourier,
            name: "pickup-dashboard-monitoring-courier",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          }
        ]
      },
      {
        path: "manage-area",
        component: PickupDashboardManageArea,
        name: "pickup-dashboard-manage-area",
        meta: {
          icon: "home",
          header: true,
          name: "Pick Up",
          permission: [
            FcsPermissionPickupDashboard.permission_pickup_dashboard_manage_area_enable
          ]
        }
      },
      {
        path: "manage-area/create",
        component: PickupDashboardManageAreaCreate,
        name: "pickup-dashboard-create-manage-area",
        meta: {
          title: "Atur Area Dedicated",
          header: true,
          hidden:true,
          name: "Pick Up ",
          permission: [
            FcsPermissionPickupDashboard.permission_pickup_dashboard_manage_area_enable
          ]
        }
      },
      {
        path: "monitoring/all-pickup",
        component: PickupDashboardMonitoringAllPickup,
        name: "pickup-dashboard-monitoring-all-pickup",
        redirect: "/pickup-dashboard/monitoring/all-pickup/crrotw",
        meta: {
          header: true,
          hidden: true,
          permission: [
            FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
          ]
        },
        children: [
          {
            path: "crrotw",
            component: PickupDashboardMonitoringAllPickupCRROTW,
            name: "pickup-dashboard-monitoring-all-pickup-crrotw",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          },
          {
            path: "crrpic",
            component: PickupDashboardMonitoringAllPickupCRRPIC,
            name: "pickup-dashboard-monitoring-all-pickup-crrpic",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          },
          {
            path: "crrdon",
            component: PickupDashboardMonitoringAllPickupCRRDON,
            name: "pickup-dashboard-monitoring-all-pickup-crrdon",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          },
          {
            path: "crrnfd",
            component: PickupDashboardMonitoringAllPickupCRRNFD,
            name: "pickup-dashboard-monitoring-all-pickup-crrnfd",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          }
        ]
      },
      {
        path: "monitoring/courier/:id",
        component: PickupDashboardMonitoringCourierDetail,
        name: "pickup-dashboard-monitoring-courier-detail",
        redirect: (to: any) => {
          return {
            path: `/pickup-dashboard/monitoring/courier/${to.params.id}/crrotw`
          };
        },
        meta: {
          header: true,
          hidden: true,
          permission: [
            FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
          ]
        },
        children: [
          {
            path: "crrotw",
            component: PickupDashboardMonitoringCourierDetailCRROTW,
            name: "pickup-dashboard-monitoring-courier-detail-crrotw",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          },
          {
            path: "crrpic",
            component: PickupDashboardMonitoringCourierDetailCRRPIC,
            name: "pickup-dashboard-monitoring-courier-detail-crrpic",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          },
          {
            path: "crrdon",
            component: PickupDashboardMonitoringCourierDetailCRRDON,
            name: "pickup-dashboard-monitoring-courier-detail-crrdon",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          },
          {
            path: "bkd",
            component: PickupDashboardMonitoringCourierDetailBKD,
            name: "pickup-dashboard-monitoring-courier-detail-bkd",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          },
          {
            path: "crrcnc",
            component: PickupDashboardMonitoringCourierDetailCRRCNC,
            name: "pickup-dashboard-monitoring-courier-detail-crrcnc",
            meta: {
              header: true,
              hidden: true,
              permission: [
                FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
              ]
            }
          }
        ]
      },
      {
        path: "monitoring/courier/:id/booking",
        name: "pickup-dashboard-monitoring-courier-booking",
        component: PickupDashboardMonitoringCourierBookingPickup,
        meta: {
          hidden: true,
          permission: [FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable],
        },
      },
      {
        path: "monitoring/courier/:id/transfer-pickup",
        component: PickupDashboardMonitoringCourierTransferPickup,
        name: "pickup-dashboard-monitoring-courier-detail-transfer-pickup",
        meta: {
          header: true,
          hidden: true,
          permission: [
            FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
          ]
        }
      },
      {
        path: "monitoring/courier/:id/booking",
        name: "pickup-dashboard-monitoring-courier-booking",
        component: PickupDashboardMonitoringCourierBookingPickup,
        meta: {
          hidden: true,
          permission: [
            FcsPermissionPickupDashboard.permission_pickup_dashboard_monitoring_enable
          ]
        }
      }
    ]
  }
];
